export enum ResumeEventStatusType
{
  MainEventActiveOrFinished = 1,
  RepeatedEvent=2,
  AllowResume=3
}
